import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

// Typed hooks for better TypeScript support
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// Custom hooks for specific slices
export const useAuth = () => {
  const auth = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  
  return {
    ...auth,
    dispatch,
  };
};

export const useBookings = () => {
  const bookings = useAppSelector((state) => state.bookings);
  const dispatch = useAppDispatch();
  
  return {
    ...bookings,
    dispatch,
  };
};

export const usePriceList = () => {
  const priceList = useAppSelector((state) => state.priceList);
  const dispatch = useAppDispatch();
  
  return {
    ...priceList,
    dispatch,
  };
};

export const useContact = () => {
  const contact = useAppSelector((state) => state.contact);
  const dispatch = useAppDispatch();
  
  return {
    ...contact,
    dispatch,
  };
};

// Utility hook for API calls with loading states
export const useApiCall = () => {
  const dispatch = useAppDispatch();
  
  const executeApiCall = useCallback(async (asyncThunk, ...args) => {
    try {
      const result = await dispatch(asyncThunk(...args));
      return result;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
  }, [dispatch]);
  
  return { executeApiCall };
};
